<template>
    <div>
        <div
            class="modal fade"
            id="group"
            tabindex="-1"
            role="dialog"
            aria-labelledby="new voucher modal"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <template v-if="edit">
                            <h5 class="modal-title">Edit Voucher</h5>
                        </template>
                        <template v-else>
                            <h5 class="modal-title">New Voucher</h5>
                        </template>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="voucher">Voucher Code*</label>
                            <input
                                type="text"
                                class="form-control"
                                id="voucher"
                                placeholder="Enter Voucher"
                                v-model="voucherCode"
                                :disabled="edit"
                            />
                        </div>
                        <div class="form-group">
                            <label>Type of Discount</label>
                            <v-select
                                v-model="selectedDiscountType"
                                :options="discountTypes"
                                label="display"
                            >
                                <template v-slot:option="type">
                                    <div>
                                        {{ type.display }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="form-group">
                            <label for="voucher_amount">Amount</label>
                            <input
                                type="number"
                                class="form-control"
                                id="voucher_amount"
                                placeholder="Enter Amount"
                                v-model="amount"
                            />
                        </div>
                        <div class="form-group">
                            <label for="start_date">Start Date & Time</label>
                            <input
                                type="datetime-local"
                                class="form-control"
                                id="start_date"
                                step="1"
                                v-model="start_date"
                            />
                        </div>
                        <div class="form-group">
                            <label for="end_date">End Date & Time</label>
                            <input
                                type="datetime-local"
                                class="form-control"
                                id="end_date"
                                step="1"
                                v-model="end_date"
                            />
                        </div>
                        <div class="form-group">
                            <label for="threshold">Threshold</label>
                            <input
                                type="number"
                                class="form-control"
                                id="threshold"
                                placeholder="Enter Threshold"
                                v-model="threshold"
                            />
                        </div>
                        <div class="form-group">
                            <label for="limit">Limit</label>
                            <input
                                type="number"
                                class="form-control"
                                id="limit"
                                placeholder="Enter Limit"
                                v-model="limit"
                            />
                        </div>
                        <div class="form-group">
                            <label for="usagelimit">Usage Limit</label>
                            <input
                                type="number"
                                class="form-control"
                                id="usagelimit"
                                placeholder="Enter Usage Limit"
                                v-model="usage_limit"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="voucher()"
                        >
                            {{ edit ? "Save Voucher" : "Create Voucher" }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
            <loader :loading="loading"></loader>
        </div>
    </div>
</template>

<script>
import loader from "./loader.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import _ from "lodash";
import axios from "axios";

export default {
    components: {
        loader,
        vSelect
    },

    props: ["edit", "voucher_code", "user_id", "get_vouchers", "oms_system", "token", "api_url"],
    data() {
        return {
            loading: true,
            voucherCode: "",
            discountTypes: [
                {
                    id: 1,
                    name: "percentage",
                    display: "Percentage",
                    description: "Applies a percentage discount to an order"
                },
                {
                    id: 2,
                    name: "fixed",
                    display: "Fixed Discount",
                    description:
                        "Applies a fixed discount to an order when it exceeds a given threshhold."
                },
                {
                    id: 3,
                    name: "free_shipping",
                    display: "Free Shipping",
                    description: "Applies free shipping to an order."
                }
            ],
            selectedDiscountType: null,
            selectedDiscountTypeId: null,
            amount: null,
            voucher_type: null,
            threshold: null,
            limit: null,
            end_date: null,
            start_date: null,
            defaultDiscount: null,
            theEditVoucher: null,
            usage_limit: null
        };
    },

    mounted() {
        this.on_load();
        $("#group").on("hidden.bs.modal", () => {
            this.close_modal();
        });
    },

    methods: {
        on_load() {
            if (this.edit && this.voucher_code) {
                this.getVoucherById(this.voucher_code);
            } else {
                this.selectedDiscountType =
                    this.discountTypes && this.discountTypes[0].display;
                this.selectedDiscountTypeId =
                    this.discountTypes && this.discountTypes[0].id;
            }

            $("#group").modal("show");
            this.loading = false;
        },
        async getVoucherById(voucher_code) {
            this.loading = true;
            try {
                const response = await axios.get(
                    `${this.api_url}/api/v1/vouchers/${voucher_code}`,
                    {
                        params: {
                            system_id: this.oms_system,
                            token: this.token
                        }
                    }
                );

                const voucherData = response.data.data[0];

                this.voucherCode = voucherData.code;
                this.selectedDiscountTypeId = voucherData.type.id;
                this.selectedDiscountType = voucherData.type.display;

                this.amount = voucherData.discount;
                this.start_date = voucherData.start_at;
                this.end_date = voucherData.end_at;
                this.threshold = voucherData.threshold;
                this.limit = voucherData.limit;
                this.usage_limit = voucherData.usage_limit;
                this.active = voucherData.active;
            } catch (error) {
                alert("Error fetching voucher");
            }
            finally{
                this.loading = false;
            }
        },
        close_modal() {
            this.$emit("closeModal", false);
        },
        voucher() {
            if (this.edit) {
                this.save_voucher();
            } else {
                this.createVoucher();
            }
        },
        createVoucher() {
            this.loading=true;
            const data = {
                code: this.voucherCode,
                voucher_type_id: this.selectedDiscountType.id,
                discount: this.amount,
                start_at: this.start_date,
                end_at: this.end_date,
                threshold: this.threshold,
                limit: this.limit,
                created_by: this.user_id,
                user_id: this.user_id,
                usage_limit: this.usage_limit,
                active: 1
            };

            const params = {
                system_id: this.oms_system,
                token: this.token
            }

            axios({
                method: "POST",
                url: `${this.api_url}/api/v1/vouchers`,
                data,
                params
            })
                .then(response => {

                    this.$emit("closeModal", false);
                    $(".modal-backdrop").remove();
                })
                .catch(error => {

                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.errors["code"]  && error.response.data.errors["code"] =="The code has already been taken."
                    ) {
                        let confirm = window.confirm(
                            "Code already taken. Would you like to edit and active this voucher?"
                        );
                        if (confirm) {

                            this.$emit("updateEdit", this.voucherCode);
                            this.getVoucherById(this.voucherCode);
                        }
                    } else if (
                        error.response &&
                        error.response.data &&
                        error.response.data.errors
                    ) {
                        const errors = Object.values(
                            error.response.data.errors
                        ).flat();

                        const errorMessage = errors.join("\n");

                        alert(errorMessage);
                    } else {
                        alert("Error creating voucher");
                    }
                }).finally(()=>{
                    this.loading=false;
                })
        },
        save_voucher() {
            this.loading=true;
            const data = {
                voucher_type_id: this.selectedDiscountType.id,
                discount: this.amount,
                start_at: this.start_date,
                end_at: this.end_date,
                threshold: this.threshold,
                limit: this.limit,
                created_by: this.user_id,
                user_id: this.user_id,
                usage_limit: this.usage_limit,
                active: 1
            };

            const params = {
                system_id: this.oms_system,
                token: this.token
            };

            axios({
                method: "PATCH",
                url: `${this.api_url}/api/v1/vouchers/${this.voucher_code}`,
                data,
                params
            })
                .then(response => {
                    this.$emit("closeModal", false);
                    $(".modal-backdrop").remove();
                })
                .catch(error => {
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.errors
                    ) {
                        const errors = Object.values(
                            error.response.data.errors
                        ).flat();
                        const errorMessage = errors.join("\n");
                        alert(errorMessage);
                    } else {
                        alert("Error creating voucher");
                    }
                }).finally(()=>{
                    this.loading=false;
                })
        }
    }
};
</script>
